const {h, render, Component} = require('preact');

class RefundPaymentOptions extends Component {
  constructor(props) {
    super(props);
    this.getTitle = this.getTitle.bind(this);
    this.getPaymentOptions = this.getPaymentOptions.bind(this);
  }

  getTitle() {
    return (
      <div class="payment-options-title">
        {I18n.translate('js.modules.support.how_would_you_like_your_refund')}
      </div>
    )
  }

  isPaymentGrouponCredits() {
    return this.props.order.isPaymentGrouponCredits
  }

  isOrderExpired() {
    return this.props.order.STATE == "EXPIRED";
  }

  getPaymentOptions() {
    return (
      <div class="pay-options-select">
        <input type="radio" value="Credits" id="site-credit" name="refund-options" checked> </input>
        <label for="site-credit">
          <div class="refund-option refund-option-bt">
            <div class="refund-option-title"> {I18n.translate('js.modules.support.site_credit')}</div>
            <div class="refund-option-msg">
              {I18n.translate('js.modules.support.site_credit_info')}
            </div>
          </div>
        </label>
        <br> </br>
        <input type="radio" value="Original Payment" id="original-payment" name="refund-options"> </input>
        <label for="original-payment">
          <div class="refund-option">
            <div class="refund-option-title"> {I18n.translate('js.modules.support.original_payment_option')}</div>
            <div class="refund-option-msg">
              {I18n.translate('js.modules.support.refund_date_info')}
            </div>
          </div>
        </label>
      </div>
    )
  }

  render() {
    if (!this.isPaymentGrouponCredits() && !this.isOrderExpired()) {
      return (
        <div>
          {this.getTitle()}
          {this.getPaymentOptions()}
        </div>
      )
    }
  }
}

module.exports = RefundPaymentOptions